import { useAuthStore } from '@user-plugins/store/modules/auth'
import axios from 'axios'

const axiosInstanceUser = axios.create({
    baseURL: import.meta.env.VITE_APP_URL_API || '/api',
    withCredentials: true,
})

axiosInstanceUser.interceptors.request.use(
    (config) => {
        const authStore = useAuthStore()
        if (authStore.access_token) {
            config.headers['Authorization'] = authStore.access_token
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

axiosInstanceUser.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            const authStore = useAuthStore()
            authStore.forceLogout()
        }
        return Promise.reject(error)
    }
)

export default axiosInstanceUser
